import React from 'react';
import { ABOUT_PAGE } from '../mock';
import Reveal from './Reveal';

const Closing = () => {
  const { closing } = ABOUT_PAGE;
  return (
    <section className="border-t border-white/5 bg-ink">
      <div className="grid lg:grid-cols-2">
        {/* B&W portrait */}
        <div className="relative min-h-[55vh] overflow-hidden lg:min-h-0">
          <img
            src={closing.image}
            alt="Kanwal H. Malik — black and white portrait"
            loading="lazy"
            className="absolute inset-0 h-full w-full object-cover object-top grayscale"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-ink/40 via-transparent to-transparent" />
        </div>

        {/* Closing words */}
        <div className="flex items-center px-6 py-14 md:px-14 md:py-20 xl:px-24">
          <div>
            <Reveal>
              <div className="space-y-1.5">
                {closing.lines.map((line) => (
                  <p
                    key={line}
                    className="font-serif text-xl font-light tracking-[0.03em] text-neutral-200 md:text-2xl"
                  >
                    {line}
                  </p>
                ))}
              </div>
            </Reveal>
            <Reveal delay={200}>
              <div className="my-9 h-px w-12 bg-gold" />
            </Reveal>
            <Reveal delay={300}>
              <p className="font-serif text-3xl font-light tracking-[0.04em] text-white md:text-4xl">
                {closing.statement}
              </p>
            </Reveal>
            <Reveal delay={420}>
              <p className="mt-12 font-script text-5xl text-gold/90 md:text-6xl">
                {closing.signature}
              </p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Closing;
